
            //------------------------------------------------------------------------------
            // <auto-generated>
            //     This code was generated from a template.
            //
            //     Manual changes to this file may cause unexpected behavior in your application.
            //     Manual changes to this file will be overwritten if the code is regenerated.
            // </auto-generated>
            //------------------------------------------------------------------------------
        
	export enum Localization {
		 Account = 'account',
		 AccountAlreadyConfirmed = 'accountAlreadyConfirmed',
		 AccountConfirmationFailed = 'accountConfirmationFailed',
		 AccountConfirmationSuccess = 'accountConfirmationSuccess',
		 AccountDeletedText = 'accountDeletedText',
		 AccountDeletedTitle = 'accountDeletedTitle',
		 ActivateBuildingDescription = 'activateBuildingDescription',
		 ActivateMaintenanceDescription = 'activateMaintenanceDescription',
		 ActivateRentalDescription = 'activateRentalDescription',
		 ActivateResidenzDescription = 'activateResidenzDescription',
		 ActivateRoomsDescription = 'activateRoomsDescription',
		 AdditionalNotes = 'additionalNotes',
		 ApplicationName = 'applicationName',
		 Back = 'back',
		 BadPasswordLength = 'badPasswordLength',
		 BuildingAppDescription = 'buildingAppDescription',
		 BuildingAppLabel = 'buildingAppLabel',
		 ConfirmAccount = 'confirmAccount',
		 ConfirmPassword = 'confirmPassword',
		 CreateAccount = 'createAccount',
		 Email = 'email',
		 ForgotPassword = 'forgotPassword',
		 GetStarted = 'getStarted',
		 GoToLoginPage = 'goToLoginPage',
		 IHaveReadAndAgreeToTheLicenseAgreementAbove = 'iHaveReadAndAgreeToTheLicenseAgreementAbove',
		 IHaveReadAndAgreeToThePrivacyPolicy = 'iHaveReadAndAgreeToThePrivacyPolicy',
		 KeepMeLoggedIn = 'keepMeLoggedIn',
		 Launch = 'launch',
		 LicenseAgreement = 'licenseAgreement',
		 LicenseNotAgreed = 'licenseNotAgreed',
		 Login = 'login',
		 LoginAgain = 'loginAgain',
		 LoginTitle = 'loginTitle',
		 Logout = 'logout',
		 MaintenanceAppDescription = 'maintenanceAppDescription',
		 MaintenanceAppLabel = 'maintenanceAppLabel',
		 Password = 'password',
		 PasswordsDoNotMatch = 'passwordsDoNotMatch',
		 PasswordSetError = 'passwordSetError',
		 PasswordSetSuccess = 'passwordSetSuccess',
		 Photos = 'photos',
		 RentalAppDescription = 'rentalAppDescription',
		 RentalAppLabel = 'rentalAppLabel',
		 RequestFreeTrial = 'requestFreeTrial',
		 Reset = 'reset',
		 ResetPassword = 'resetPassword',
		 ResetPassword_InfoAlinea1 = 'resetPassword_InfoAlinea1',
		 ResetPassword_InfoAlinea2 = 'resetPassword_InfoAlinea2',
		 ResetPassword_InfoTitle = 'resetPassword_InfoTitle',
		 ResetPasswordSuccess = 'resetPasswordSuccess',
		 ResidenzAppDescription = 'residenzAppDescription',
		 ResidenzAppLabel = 'residenzAppLabel',
		 RoomAppDescription = 'roomAppDescription',
		 RoomAppLabel = 'roomAppLabel',
		 SelectAPlatform = 'selectAPlatform',
		 SetPassword = 'setPassword',
		 SignedOut = 'signedOut',
		 SignOutErrorMessage = 'signOutErrorMessage',
		 SignOutMessage = 'signOutMessage',
		 StartFreeTrial = 'startFreeTrial',
		 Submit = 'submit',
		 TryAgain = 'tryAgain',
		 TwoFactorExplanation = 'twoFactorExplanation',
		 TwoFactorOTPInvalidMessage = 'twoFactorOTPInvalidMessage',
		 TwoFactorOTPPlaceholder = 'twoFactorOTPPlaceholder',
		 TwoFactorTitle = 'twoFactorTitle',
		 UnconfirmedAccount = 'unconfirmedAccount',
		 Visit = 'visit',
		 WelcomeUser = 'welcomeUser',
		 WrongEmailOrPassword = 'wrongEmailOrPassword',
	}


